// Copyright 2025. WebPros International GmbH. All rights reserved.

import { connect } from 'react-redux';
import { RootState } from 'admin/core/store';
import { RescueTab } from 'common/components/ServerTabs/RescueTab/RescueTab';
import { ComputeResourceVmStatus } from 'common/api/resources/ComputeResourceVm';
import { LOADING_FLAGS } from 'common/modules/app/loadingFlags/constants';
import {
    resetPassword,
    updateBootMode,
} from 'common/modules/computeResourceVm/actions';
import {
    bindActionCreators,
    Dispatch,
} from 'redux';
import { hasPermission } from 'common/modules/permission/selectors';
import { PERMISSION_LIST } from 'common/modules/permission/constants';

const mapStateToProps = (state: RootState) => {
    const server = state.computeResourceVm.item;

    return {
        authId: state.auth.user.id,
        server,
        isSwitchingBootMode: state.app.loadingFlags.has(LOADING_FLAGS.COMPUTE_RESOURCE_VM_SWITCH_BOOT_MODE) ||
            state.computeResourceVm.item.status === ComputeResourceVmStatus.UPDATING,
        isResettingPassword: state.app.loadingFlags.has(LOADING_FLAGS.RESET_COMPUTE_RESOURCE_VM_PASSWORD) ||
            state.computeResourceVm.item.status === ComputeResourceVmStatus.CHANGING_PASSWORD,
        canBootFromISOImage: hasPermission(state, PERMISSION_LIST.BOOT_FROM_ISO_IMAGES),
        canGetISOImage: hasPermission(
            state,
            PERMISSION_LIST.GET_ISO_IMAGES,
            PERMISSION_LIST.MANAGE_ALL_ISO_IMAGES,
            PERMISSION_LIST.MANAGE_OWNED_ISO_IMAGES
        ),
        canResetRootPassword: hasPermission(
            state,
            PERMISSION_LIST.MANAGE_SERVERS,
            PERMISSION_LIST.RESET_ROOT_PASSWORD
        ),
        canChangeBootMode: hasPermission(
            state,
            PERMISSION_LIST.MANAGE_SERVERS,
            PERMISSION_LIST.CHANGE_SERVERS_BOOT_MODE
        ),
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    resetPassword: bindActionCreators(resetPassword, dispatch),
    updateBootMode: bindActionCreators(updateBootMode, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(RescueTab);
